export { default as i18n } from './config';
export { getBootLocale, getBootDirection } from './config';
export type { AppLocale } from './config';
export { resolve, resolveStr, setLocale, hasLocale } from './localized';
export type { Localized, Localizable } from './localized';

import { getBootLocale } from './config';

/**
 * Build a URL with a different `lang` query param while keeping all other
 * search params. Used by the public language toggle to trigger a full
 * page reload at a new locale.
 */
export function buildLocaleUrl(targetLocale: 'he' | 'en'): string {
  if (typeof window === 'undefined') return '';
  const url = new URL(window.location.href);
  if (targetLocale === 'he') url.searchParams.delete('lang');
  else url.searchParams.set('lang', 'en');
  return url.pathname + url.search + url.hash;
}

/** Hook-less getter for the active locale (boot-time decision). */
export function getActiveLocale() {
  return getBootLocale();
}
